import { importProvidersFrom, ApplicationConfig, provideZoneChangeDetection, NgModule } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { CustomeInterceptor } from './interceptor/custome.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { OverlayContainer } from '@angular/cdk/overlay';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
export const appConfig: ApplicationConfig = {
  providers: [

    
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    { provide: OverlayContainer },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomeInterceptor,
      multi: true
    },
    provideAnimations(),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      progressBar: true,
    }),


    importProvidersFrom(NgxDaterangepickerMd.forRoot())




  ]


};
